<section class="header">
    <div class="container">

        <img class="glitch" data-text="HAUNTED" src="https://res.cloudinary.com/dadqp2oia/image/upload/v1629672279/Music%20Website/Logos/haunted-logo_t8ad12.png" alt="image of Haunted text that is animated in a glitch">

        <p class="subtitle">EP Out Now</p>
    </div>
    <div class="scanlines"></div>
</section>
